import { BOSS_MAX_HP } from './corePhases';
import './CoreHealthFill.css';
import HealthLossFragments from './HealthLossFragments';

export const HealthShieldSection = ({ hp, shield, scale, label = 'Core' }) =>
  shield > 0 ? (
    <span
      className="coreboundCoreShieldSection"
      role="img"
      aria-label={`${label} shield: blocks ${shield} damage`}
      style={{
        left: `${(hp / scale) * 100}%`,
        width: `${(shield / scale) * 100}%`,
      }}
    />
  ) : null;

const CoreHealthFill = ({ hp, shield = 0, reduceMotion = false }) => {
  const protection = Math.max(0, shield);
  const health = Math.max(0, Math.min(BOSS_MAX_HP, hp));
  const scale = Math.max(BOSS_MAX_HP, health + protection);
  return (
    <>
      <span
        className="coreboundCoreHpFill"
        style={{ width: `${(health / scale) * 100}%` }}
      />
      <HealthLossFragments
        hp={health}
        maxHp={scale}
        reduceMotion={reduceMotion}
      />
      <HealthShieldSection hp={health} shield={protection} scale={scale} />
    </>
  );
};

export const CoreShieldValue = ({ shield = 0 }) =>
  shield > 0 ? (
    <small className="coreboundCoreShieldValue">⬡ {shield} SHIELD</small>
  ) : null;

export default CoreHealthFill;
